import { render, staticRenderFns } from "./CurriculumJournalHeaderRow.vue?vue&type=template&id=2ad44c0e&scoped=true&"
import script from "./CurriculumJournalHeaderRow.vue?vue&type=script&lang=ts&"
export * from "./CurriculumJournalHeaderRow.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumJournalHeaderRow.vue?vue&type=style&index=0&id=2ad44c0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad44c0e",
  null
  
)

export default component.exports